import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TagContainer } from './styles';
import TagSkeleton from './TagSkeleton';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
export function Tag({ label, bgColor, labelOptions, iconOptions, loading, 'data-testid': dataTestid, }) {
    if (loading)
        return _jsx(TagSkeleton, { "data-testid": `${dataTestid}-skeleton`, label: label, iconOptions: iconOptions });
    return (_jsxs(TagContainer, { "data-testid": dataTestid || 'tag-container', bgColor: bgColor, iconOptions: iconOptions, children: [iconOptions && _jsx(Icon, { ...iconOptions }), _jsx(Typography, { variant: "ParagraphSmall/Semibold", color: labelOptions?.color || '--surface-white', ...labelOptions, children: label })] }));
}
//# sourceMappingURL=index.js.map